import pluralize from 'pluralize'

import { slugToNice } from '../utils/stringUtils'
import { formatPrice } from '../utils/pricing'
import { LineItemsProps, ListingProps } from './types'

const LineItemLabel = ({
  item,
  pricingSuffix,
}: {
  item: Pick<LineItemsProps, 'itemType' | 'price' | 'quantity'>
  pricingSuffix: ListingProps['pricingSuffix']
}) => {
  if (item.itemType === 'rental_fee') {
    return (
      <span>
        {`${formatPrice(item.price)} x ${pluralize(
          pricingSuffix.split('_')[1],
          item.quantity,
          true
        )}`}
      </span>
    )
  }

  return (
    <span>
      {item.quantity > 1
        ? `${item.quantity} x ${slugToNice(item.itemType, true)}`
        : `${slugToNice(item.itemType, true)}`}
    </span>
  )
}

export default LineItemLabel
